import { UntypedFormControl } from "@angular/forms";

export const validatePhoneNumber = (formControl: UntypedFormControl) => {
  const value = formControl.value as string;

  if (!value) {
    return null;
  }

  const cleanValue = String(value).replace(/[\s()-]/g, "");

  const isValidFormat =
    /^\+?\d+$/.test(cleanValue) || /^\d{10}$/.test(cleanValue);

  return isValidFormat ? null : { phoneNumberInvalid: true };
};

export const validateNonRequiredPhoneNumber = (
  formControl: UntypedFormControl,
) => (!formControl.value ? null : validatePhoneNumber(formControl));
